




































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import InputFile from '../../core/components/InputFile.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getIdsFromList
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    MultipleSelect,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import ModalCsvWizard from './ModalCsvWizard.vue';

@Component({
    components: {
        Loading,
        SimpleMap,
        InputFile,
        Combobox,
        MultipleSelect,
        Button,
        ModalCsvWizard
    }
})
export default class ModalUploadCSV extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() vehicleID: number;
    @Prop() harvestList: Array<object>;
    harvestRV: boolean = false;
    fileSelected: any = [];
    harvestSelected: any = [];
    fileContent: any = null;
    fileLoaded: boolean = false;
    visibleModalCsvWizard: boolean = false;
    step: number = 1;
    firstLineCsv: string | undefined = '';
    fileRows: string[] = [];

    nextStep(){
        this.step++;
    }
    prevStep(){
        this.step--;
    }

    showWizardStep(){
        this.nextStep();
        this.visibilityModalCsvWizard(true);
    }


    visibilityModalCsvWizard(value){
        this.visibleModalCsvWizard = value;
    }

    customLabelHarvest(option) {
        return `${option.company.name} - ${option.name}`;
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    selectedFile(file) {
        this.fileSelected = file;
    }

    uploadFile() {
        let reader = new FileReader();
        let self = this;
        this.fileContent = null;
        this.fileLoaded = false;
        this.fileContent = this.fileSelected[0];
        reader.readAsText(this.fileSelected[0]);
        reader.onload = (e) => {
            let text = (<string>reader.result);
            self.fileRows = text.split('\n');
            self.firstLineCsv = text.split('\n').shift();
            self.fileLoaded = true;
        };
    }

    clearFile() {
        // console.log('clear file');
    }

    saveCSV(wizardData) {
        this.showLoadingDialog('Subiendo CSV... <br> <small>(Ésta acción puede tomar unos minutos)</small>');
        InsuranceServices.postHarvestCSV(this.getData(wizardData))
            .then(res => {
                this.showSuccessLoadingDialog(res, 'CSV subido con éxito');
                this.$emit('add-new-csv', res['perf_map_csvs']);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo subir el CSV');
            });
    }

    getData(wizardData) {
        let harvestsIds = getIdsFromList(this.harvestSelected);
        let form_data = new FormData();
        form_data.append('file', this.fileContent);
        form_data.append('vehicle_id', this.vehicleID.toString());
        form_data.append('harvest_id', harvestsIds);
        form_data.append('separator', wizardData['separator']);
        form_data.append('decimal_separator', wizardData['decimal_separator']);
        form_data.append('timestamp_format', wizardData['timestamp_format']);
        form_data.append('x_column', wizardData['x_column']);
        form_data.append('y_column', wizardData['y_column']);
        form_data.append('timestamp_column', wizardData['timestamp_column']);
        form_data.append('perf_column', wizardData['perf_column']);
        form_data.append('hum_column', wizardData['hum_column']);
        form_data.append('append', wizardData['append'].toString());
        form_data.append('perf_unit', wizardData['perf_unit'].toString());
        return form_data;
    }

    handleSelected(itemToAdd) {
        this.harvestSelected.push(itemToAdd);
    }

    handleRemoveOption(itemToRemove) {
        this.harvestSelected = this.harvestSelected.filter(item => item.id !== itemToRemove.id);
    }

    get formIsValid() {
        if (this.harvestSelected.length == 0) {
            return false;
        }
        if (this.fileContent == null) {
            return false;
        }

        return true;
    }

    @Emit()
    closeModal() {}

    mounted() {}
}
